import HttpClient from "shared/repositories/HttpClient";
import { GetFreeFortuneResultContentRes } from "shared/types";

export class FreeFortuneResultContentRepository {
  private getObjectPath(id: string | number) {
    return `/free_fortune/result_contents/${id}`;
  }

  public getObject(id: string | number) {
    const path = this.getObjectPath(id);

    return {
      path,
      data: () =>
        HttpClient.miror
          .get<GetFreeFortuneResultContentRes>(path)
          .then((res) => res.data),
    };
  }
}
